import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSUnidadeMedidaClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/unidade-medida');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Unidades de Medida');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/unidade-medida', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Unidades de Medida');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/unidade-medida', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Unidades de Medida');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/unidade-medida/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Unidades de Medida');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/unidade-medida/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Unidades de Medida');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/unidade-medida/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Unidades de Medida');
    }
  }
}
